import sliceCreator from '../../index.jsx';
import {GET_ALL_FARMERS} from '../../../constants/index.jsx';
const _getAllFarmersAction = sliceCreator('GET_ALL_FARMERS', GET_ALL_FARMERS, 'get');

const { asyncAction: getAllFarmersAction, reducer, clearData: clearGetAllFarmersAction } = _getAllFarmersAction;

export default reducer;

export {
    getAllFarmersAction,
    clearGetAllFarmersAction
}